import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card borderNone">
                          <div className="card-body">
                            <h5 className="card-title">Kontakt</h5>
                            <h6 className="card-subtitle mb-2 text-muted"></h6>
                            <p className="card-text">
                                <div className="row">
                                    <div className="col-12">
                                        Dipl.-&Ouml;konom R&uuml;diger Heckmann
                                        <br />
                                        Inselstraße 11
                                        <br />
                                        40479 D&uuml;sseldorf
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1">
                                        Telefon:
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-11">
                                        <a className="colorBlack" href="tel:+492115370700">+49 (211) 53 70 700</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1">
                                        Fax: 
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-11">
                                        +49 (211) 53 70 773
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1">
                                        E-Mail:
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-11">
                                        <a className="colorBlack" href="mailto://r.heckmann@heckmann-steuerberatung.de" target="_blank">r.heckmann@heckmann-steuerberatung.de</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1">
                                        Web:
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-11">
                                        <a className="colorBlack" href="http://www.heckmann-steuerberatung.de" target="_blank">http://www.heckmann-steuerberatung.de</a>
                                    </div>
                                </div>
                            </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/Contact.js